import React, { Component } from 'react';
import { ReactComponent as TriangleWhite } from '../../../assets/images/triangle-joint-white.svg';
import { ReactComponent as TriangleBlue } from '../../../assets/images/triangle-joint-blue.svg';
import { ReactComponent as SquareWhite } from '../../../assets/images/square-joint-white.svg';
import { ReactComponent as SquareBlue } from '../../../assets/images/square-joint-blue.svg';
import styles from './styles';
import { css } from 'aphrodite';

class JobTypeButton extends Component {

    render() {
        const { isSelected, title, type, onSelectType } = this.props;

        return (
            <div className={css(styles.jobTypeButton, isSelected ? styles.selected : '')}
                 onClick={onSelectType} >
                <span className={css(styles.span)}>{title}</span>

                {type === 'triangle' && isSelected ? <TriangleWhite className={css(styles.svg)} /> : '' }
                {type === 'triangle' && !isSelected ? <TriangleBlue className={css(styles.svg)} /> : '' }

                {type === 'square' && isSelected ? <SquareWhite className={css(styles.svg)} /> : '' }
                {type === 'square' && !isSelected ? <SquareBlue className={css(styles.svg)} /> : '' }
            </div>
        );
    }
}

export default JobTypeButton;
